import { stringArray, type StringArrayColumnParams } from './stringArray';
import type { ColDefFactory, Column } from './types';

export type MarketsColumnParams = Omit<StringArrayColumnParams, 'getDisplayName'>;

export const markets: ColDefFactory<Column<MarketsColumnParams>> = column => ({
  ...stringArray({
    ...column,
    params: {
      ...column.params,
      getDisplayName: (marketName, context) => context.current.marketDisplayNameByName?.get(marketName) ?? marketName,
    },
  }),
});
